import { Navigate, useLocation, useParams } from "react-router-dom";

import AngebotReviewPage from "./AngebotReviewPage";
import BelegDetailPage from "./BelegDetailPage";
import OrderConfirmationReviewPage from "./OrderConfirmationReviewPage";

// One address for every purchasing document (#546): /belege/<id>. Which page
// answers is decided by the document's own kind, which its id carries. The
// pages still differ in their actions; the way in no longer does.

/** Deep links of the old per-kind addresses keep working (#546). */
export function BelegDetailRedirect({ param }: { param: string }) {
  const params = useParams();
  const { search, hash, state } = useLocation();
  const id = params[param];
  if (!id) return <Navigate to="/belege" replace />;
  // Older deep links can carry an opaque id without a document-kind prefix.
  // Keep their kind from the old route rather than interpreting them as invoices.
  if (!id.includes(":")) {
    if (param === "angebotId") return <AngebotReviewPage />;
    if (param === "orderConfirmationId") return <OrderConfirmationReviewPage />;
  }
  return <Navigate to={`/belege/${encodeURIComponent(id)}${search}${hash}`} replace state={state} />;
}

export function BelegeCreditRedirect() {
  const { search, hash, state } = useLocation();
  const params = new URLSearchParams(search);
  params.set("type", "gutschrift");
  return <Navigate to={`/belege?${params}${hash}`} replace state={state} />;
}

export default function BelegDetailRoute() {
  const { belegId = "" } = useParams();
  switch (belegId.split(":")[0]) {
    case "angebot":
      return <AngebotReviewPage />;
    case "einzelauftrag":
      return <OrderConfirmationReviewPage />;
    default:
      return <BelegDetailPage />;
  }
}
